import { render, staticRenderFns } from "./ExpandableCard.vue?vue&type=template&id=a3588d08&scoped=true&"
import script from "./ExpandableCard.vue?vue&type=script&lang=ts&"
export * from "./ExpandableCard.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandableCard.vue?vue&type=style&index=0&id=a3588d08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3588d08",
  null
  
)

export default component.exports